// extracted by mini-css-extract-plugin
module.exports = {"button":"indicador_button__U-Qv-","filtro":"indicador_filtro__2XF8v"};